import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Repo from "../../Repository/Repo";

const initialState = {
  loading: false,
  error: "",
  categories: [],
};

export const getCategories = createAsyncThunk("cats/fetchcats", () => {
  return Repo.category({
    request: {
      method: "getDaybookCategories",
      data: {
        company_code: localStorage.getItem("companyCode"),
      },
    },
  })
    .then(({ data }) => data.response.data.categoriesArr)
    .catch((err) => console.log(err));
});

export const categorySlice = createSlice({
  name: "addCategory",
  initialState,
  reducers: {
    addCat: (state, action) => {
      state.categories.unshift(action.payload);
    },
    removeCat: (state, action) => {
      const { index } = action.payload;
      state.categories.splice(index, 1);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCategories.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCategories.fulfilled, (state, action) => {
      state.loading = false;
      state.categories = action.payload;
      state.error = "";
    });
    builder.addCase(getCategories.rejected, (state, action) => {
      state.loading = false;
      state.categories = [];
      state.error = action.error.message;
    });
  },
});

export const { addCat, removeCat } = categorySlice.actions;

export default categorySlice.reducer;
